import React from "react";
import { Link } from "react-router-dom";
import {
  getLeagueWaiverSummaryLine,
  getSeasonCalendarBulletItems,
} from "../utils/transactionWindowCopy";

export default function SeasonCalendarBanner({
  showDraftTip = true,
  compact = false,
  style = {},
  leagueSettings = null,
  variant = leagueSettings ? "league" : "landing",
}) {
  const bullets = getSeasonCalendarBulletItems();
  const isLeague = variant === "league" && leagueSettings;

  return (
    <div
      className={`ffb-season-calendar${compact ? " ffb-season-calendar-compact" : ""}`}
      style={style}
    >
      <div className="ffb-season-calendar-title">2026 Season Calendar</div>
      <ul className="ffb-season-calendar-list">
        {bullets.map((text) => (
          <li key={text}>{text}</li>
        ))}
      </ul>
      {isLeague ? (
        <p className="ffb-season-calendar-meta">{getLeagueWaiverSummaryLine(leagueSettings)}</p>
      ) : (
        <p className="ffb-season-calendar-meta">
          All leagues share the same NFL calendar. Waiver and lineup rules apply once your league drafts.
        </p>
      )}
      <p className="ffb-season-calendar-faq">
        <Link to="/about#faq" className="ffb-season-calendar-faq-link">
          Waivers, lineups &amp; full calendar details →
        </Link>
      </p>
      {showDraftTip && (
        <p className="ffb-season-calendar-tip">
          Leagues that draft after Week 1 scoring begins still follow this calendar — missed early weeks will not count.
        </p>
      )}
    </div>
  );
}
